export default "__VITE_ASSET__39b26013__"